/**
 * utils/actAs.js — «ӨӨР ХЭРЭГЛЭГЧЭЭР НЭВТРЭХ»-ийн БУЦАХ ЗАМ.
 *
 * Хэрэглэгч солих механизм нь анхнаасаа байсан:
 *   · UI     — components/layout/layout.js, `Alt+T` товчлуур
 *   · API    — POST /user/change {tn} (Resources/user.py → ChangeUser)
 *   · Эрх    — Redis дэх `developer == 1` ажилтанд л зөвшөөрөгдөнө
 * SSO нь зорилтот ажилтны ЖИНХЭНЭ токеныг буцаадаг тул эрх, роль, бүлэг
 * бүгд яг таг ирнэ.
 *
 * ⚠ ЭНЭ ФАЙЛ ЮУГ НЭМЖ БАЙНА ВЭ — БУЦАХ ЗАМ:
 *   `layout.js` нь солихдоо `localStorage.clear()` хийдэг тул хөгжүүлэгч
 *   ӨӨРИЙН токеноо алдаж, буцахын тулд SSO-гоор дахин нэвтрэх шаардлагатай
 *   болдог байв. Тиймээс өөрийн токеныг `sessionStorage`-д хадгална —
 *   `localStorage.clear()` түүнд хүрэхгүй.
 *
 *   Буцах нь СЕРВЕРЭЭС ХАМААРАХГҮЙ байх ЁСТОЙ: дүрд орсны дараа апп нь тэр
 *   хэрэглэгчийн эрхийг хардаг тул эрх багатай хүн болж орвол цэс хоосон,
 *   API 403 болно. Буцах нь зөвхөн локал утгыг сэргээнэ.
 */

export const ORIG_TOKEN_KEY = "actAsOrigToken";
export const ORIG_TN_KEY = "actAsOrigTn";
export const ACT_AS_TN_KEY = "actAsTn";

/** Солихын ӨМНӨ дуудна — өөрийн токеныг аварна. */
export function rememberSelf(tn) {
  try {
    const my = localStorage.getItem("token");
    if (my) {
      // sessionStorage — `localStorage.clear()` үүнд ХҮРЭХГҮЙ.
      sessionStorage.setItem(ORIG_TOKEN_KEY, my);
      if (tn) sessionStorage.setItem(ORIG_TN_KEY, String(tn));
    }
  } catch {
    /* private горимд хаалттай байж болно */
  }
}

/** Солисны ДАРАА дуудна — ямар дүрд орсныг тэмдэглэнэ. */
export function markActAs(tn) {
  try {
    sessionStorage.setItem(ACT_AS_TN_KEY, String(tn || ""));
  } catch {
    /* үл тоомсорлоно */
  }
}

/** Одоо өөр хэрэглэгчийн дүрд байгаа эсэх. */
export function getActAs() {
  try {
    if (!sessionStorage.getItem(ORIG_TOKEN_KEY)) return "";
    return (sessionStorage.getItem(ACT_AS_TN_KEY) || "?").trim();
  } catch {
    return "";
  }
}

/** Өөрийн бүртгэл рүү буцах — СЕРВЕР РҮҮ ХАНДАХГҮЙ. */
export function returnToSelf() {
  try {
    const orig = sessionStorage.getItem(ORIG_TOKEN_KEY);
    sessionStorage.removeItem(ORIG_TOKEN_KEY);
    sessionStorage.removeItem(ORIG_TN_KEY);
    sessionStorage.removeItem(ACT_AS_TN_KEY);
    if (orig) {
      // Солих үед цэс/кэш нь тэр хэрэглэгчийнхээр үлдсэн тул мөн цэвэрлэнэ.
      localStorage.clear();
      localStorage.setItem("token", orig);
    }
  } catch {
    /* үл тоомсорлоно */
  }
  window.location.replace("/");
}
